import React, { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, EffectFade } from 'swiper/modules'; // EffectFade saya kembalikan

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade'; // Style Fade saya kembalikan
import './EventDetail.css';

// Lazy Load Components
const Quote = React.lazy(() => import('./Quote'));
const WhyUs = React.lazy(() => import('./WhyUs'));
const Testimonial = React.lazy(() => import('./Testimonial'));
const Gallery = React.lazy(() => import('./Gallery'));

const EventDetail = () => {
    useEffect(() => {
        window.scrollTo(0, 0);

        // Tracking PageView Meta Pixel
        if (window.fbq) {
            window.fbq('track', 'PageView');
        }

        // Tracking PageView Google Analytics
        if (typeof window.gtag === 'function') {
            window.gtag('event', 'page_view', {
                page_path: window.location.pathname,
            });
        }
    }, []);

    const heroImage = "/images/kapal.png";
    
    // SAYA KEMBALIKAN: Data Foto untuk Slider
    const galleryItems = [
        "/images/mepo1.jpeg", 
        "/images/mepo2.jpeg", 
        "/images/mepo3.jpeg",
        "/images/mepo4.jpeg",
        "/images/mepo5.jpeg",
        "/images/mepo6.jpeg",
    ];

    const routeDetails = [
        { port: "Jakarta", dur: "Start", act: "Titik kumpul di Pelabuhan Tanjung Priok. Persiapan boarding." },
        { port: "Surabaya", dur: "4 Jam", act: "Transit di Tanjung Perak. Melihat kesibukan pelabuhan terbesar kedua." },
        { port: "Makassar", dur: "2 Jam", act: "Eksplorasi singkat ke Masjid Kubah 99 dan menikmati Coto Makassar." },
        { port: "Bau-Bau", dur: "2 Jam", act: "Singgah di gerbang Kesultanan Buton. Melihat Benteng Wolio." },
        { port: "Ambon", dur: "2 Jam", act: "Persinggahan terakhir di tanah Maluku sebelum menyeberang." },
        { port: "Banda Neira", dur: "Finish", act: "Tiba di surga rempah. Selamat datang di kota bersejarah." }
    ];

    const fasilitas = [
        { icon: "🚢", text: "Tiket Pelni PP" },
        { icon: "🏠", text: "Penginapan 4 Malam" },
        { icon: "🍱", text: "Makan Buffet 3x Sehari" },
        { icon: "🤿", text: "Alat Snorkeling" },
        { icon: "📸", text: "Dokumentasi & Drone" },
        { icon: "🚩", text: "Guide Lokal" },
        { icon: "🧢", text: "Tour Leader" }, // Tambahan
        { icon: "🚤", text: "Boat antar Pulau" }, // Tambahan
        { icon: "🥤", text: "Air Mineral" }, // Tambahan
        { icon: "🍪", text: "Cemilan Hopping" }, // Tambahan
        { icon: "👕", text: "Kaos Eksklusif" },
        { icon: "🎫", text: "Tiket Destinasi" },
        { icon: "🩹", text: "P3K Standar" } // Tambahan
    ];

    const pricing = [
        { city: "Jakarta", price: "4.7jt" },
        { city: "Surabaya", price: "4.4jt" },
        { city: "Makassar", price: "3.9jt" },
        { city: "Bau-bau", price: "3.5jt" },
        { city: "Ambon", price: "3.2jt" },
        { city: "Banda Neira", price: "2.7jt" }
    ];

    const waLink = "https://nejtrip.site/booking";

    const handleWaClick = () => {
        if (window.fbq) {
            window.fbq('track', 'Lead', {
                content_name: 'Banda Neira Open Trip',
                value: 2700000,
                currency: 'IDR'
            });
        }
    };

    return (
        <div className="modern-landing">
            {/* --- HERO SECTION --- */}
            <section 
                className="hero-minimal" 
                style={{ 
                    // Gradasi dari transparan (atas) ke hitam pekat (bawah)
                    backgroundImage: `linear-gradient(rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.8) 100%), url("${heroImage}")`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    color: '#fff' // Mengubah warna teks dasar menjadi putih agar kontras
                }}
            >
                <div className="container text-center">
                    <h1 className="hero-main-title">
                        Open Trip Banda Neira <br /> 
                        <span className="accent">Via Pelni</span>
                    </h1>
                    <p className="hero-desc">Ekspedisi laut menyusuri jalur rempah dunia dengan Kapal PELNI.</p>
                    <a href={waLink} onClick={handleWaClick} className="btn-cta shadow-lg mt-5">AMANKAN SLOT</a>
                </div>
            </section>

            {/* --- TIMELINE RUTE --- */}
            <section className="section-padding">
                <div className="container">
                    <h2 className="section-title text-center mb-5">Alur Pelayaran</h2>
                    <div className="v-timeline">
                        {routeDetails.map((item, index) => (
                            <div key={index} className="v-step">
                                <div className="v-marker"></div>
                                <div className="v-info">
                                    <span className="v-label">{item.dur} Transit</span>
                                    <h4 className="v-port">{item.port}</h4>
                                    <p className="v-act">{item.act}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* --- FASILITAS SWIPER --- */}
            <section className="section-padding bg-soft">
                <div className="container">
                    <h2 className="section-title text-center mb-5">Fasilitas Eksklusif</h2>
                    <Swiper
                        modules={[Pagination, Autoplay]}
                        spaceBetween={15}
                        slidesPerView={1.5}
                        breakpoints={{ 768: { slidesPerView: 3 }, 1024: { slidesPerView: 4 } }}
                        autoplay={{ delay: 2500 }}
                        pagination={{ clickable: true }}
                        className="f-swiper pb-5"
                    >
                        {fasilitas.map((f, i) => (
                            <SwiperSlide key={i}>
                                <div className="f-box text-center shadow-sm">
                                    <div className="f-icon">{f.icon}</div>
                                    <div className="f-name">{f.text}</div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </section>

            {/* --- PRICING --- */}
            <section className="section-padding">
                <div className="container text-center">
                    <h2 className="section-title mb-5">Meeting Point & Harga</h2>
                    <div className="row justify-content-center g-3">
                        {pricing.map((p, i) => (
                            <div key={i} className="col-6 col-md-4 col-lg-2">
                                <div className="price-card">
                                    <span className="p-city">{p.city}</span>
                                    <span className="p-amt">{p.price}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* --- COMPONENT: WHY US --- */}
            <React.Suspense fallback={null}>
                <div className="bg-soft">
                    <WhyUs />
                </div>
            </React.Suspense>

            {/* --- COMPONENT: GALLERY --- */}
            <React.Suspense fallback={null}>
                <Gallery />
            </React.Suspense>

            {/* --- SAYA KEMBALIKAN: PHOTO GALLERY SLIDER (100VH, SINGLE PHOTO, WHITE THEME) --- */}
            <section className="gallery-fullscreen bg-soft">
                <div className="container h-100 d-flex flex-column justify-content-center align-items-center">
                    <h2 className="section-title text-center mb-4">Dokumentasi Perjalanan</h2>
                    <div className="gallery-container-34">
                        <Swiper
                            modules={[Autoplay, Pagination, EffectFade]}
                            effect="fade"
                            slidesPerView={1}
                            loop={true}
                            autoplay={{ delay: 3500 }}
                            pagination={{ clickable: true }}
                            className="h-100"
                        >
                            {galleryItems.map((img, i) => (
                                <SwiperSlide key={i}>
                                    <div className="gallery-slide-inner">
                                        <img src={img} alt="Dokumentasi Banda Neira" className="shadow-lg" />
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </section>

            {/* --- COMPONENT: TESTIMONIAL --- */}
            <React.Suspense fallback={null}>
                <Testimonial />
            </React.Suspense>

            {/* --- FINAL CTA --- */}
            <section className="section-padding text-center bg-white">
                <div className="container">
                    <h3 className="cta-main-title fs-1">Jangan biarkan Banda Neira hanya jadi <span className="accent">mimpi di layar ponselmu.</span></h3>
                    <p className="text-muted mb-5 px-md-5">Sejarah, keindahan bawah laut, dan hangatnya persaudaraan di kapal PELNI menantimu.</p>
                    <div className="d-flex flex-column align-items-center gap-3">
                        <a href={waLink} onClick={handleWaClick} className="btn-cta btn-lg px-5 shadow-xl">AMANKAN SLOT SEKARANG</a>
                    </div>
                </div>
            </section>
            
            <div className="py-5">
                <React.Suspense fallback={null}>
                    <Quote />
                </React.Suspense>
            </div>
        </div>
    );
};

export default EventDetail;